import { set, when } from 'cerebral/operators'

import changeFilter from '../actions/changeFilter.js'

export default [
  changeFilter,
  when('state:users.searchOptions.showSnackbar', [false]),
  {
    false: [set('users.searchOptions.showSnackbar', true)],
    otherwise: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/user/chains/onFilterChange.js